export default __webpack_public_path__ + "static/media/template13.17fd58f2.svg";